import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin({
  name: 'aleno-script',
  dependsOn: ['sv:init-data'],
  async setup() {
    const { siteInfo } = useInitData()

    if (siteInfo.value?.domain === 'erlebnis_rheinfall') {
      useHead({
        script: [
          {
            src: 'https://mytools.aleno.me/reservations/v2.0/reservations.js',
            defer: true,
          },
        ],
        link: [
          {
            rel: 'stylesheet',
            href: 'https://mytools.aleno.me/reservations/v2.0/reservations.css',
          },
        ],
      })
    }
  },
})
